import { Controller } from "@hotwired/stimulus";

/**
 * 購入前アンケートの質問
 */
export class QuestionController extends Controller {
  static values = { type: String };
  static targets = ["options", "lastBlock"];

  connect() {
    this.#update();
  }

  changeType(event) {
    this.typeValue = event.params?.type || event.currentTarget.value;
    this.#update();
  }

  get #showOptions() {
    return ["radio", "checkbox"].includes(this.typeValue);
  }

  #update() {
    if (!this.hasOptionsTarget) return;
    for (const options of this.optionsTargets) {
      options.hidden = !this.#showOptions;
      for (const el of options.querySelectorAll("input, select, textarea")) {
        el.disabled = !this.#showOptions;
      }
    }
    // 選択肢を表示しない時に線が付かないようにする
    if (this.hasLastBlockTarget) {
      this.lastBlockTarget.classList.toggle("form__block--no-border", !this.#showOptions);
    }
  }
}
